var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-sm-6 col-md-4 col-lg-3 mb-4"},[_c('router-link',{staticClass:"text-decoration-none text-black",attrs:{"to":{
      name: 'course-data',
      params: {
        id: _vm.item.id,
        name: _vm.linkString( _vm.item.name ),
        author: _vm.linkString( _vm.item.user.name )
      }
    }}},[_c('div',{staticClass:"card rounded-3 course-item",staticStyle:{"height":"380px"}},[_c('div',{staticClass:"card-body p-0 m-0 rounded-0 p-2 position-relative"},[(_vm.item.thumbnail)?_c('img',{staticClass:"card-img rounded-3",attrs:{"src":("" + _vm.api_url + (_vm.item.thumbnail.url))}}):_vm._e(),_c('div',{staticClass:"px-1 py-2"},[_c('h6',[_vm._v(_vm._s(_vm.item.name))]),_c('user-data',{attrs:{"user":_vm.item.user}}),_c('course-values',{staticClass:"position-absolute w-100 pr-4",staticStyle:{"bottom":"0"},attrs:{"item":{
              'workload': _vm.item.workload,
              'value': _vm.item.value,
              'value_sale': _vm.item.value_sale,
              'is_free': _vm.item.is_free,
            }}})],1)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }